import * as React from "react";
import { Button } from "react-bootstrap"

import { appContext } from "../App/appContext"

import { SimpleComponent } from "./SimpleComponent"
import { getStyle } from "./navigation"
import { ILinkButtonProps } from "./LinkButton";

export class ButtonLinkButton extends SimpleComponent<ILinkButtonProps> {
    constructor(props: ILinkButtonProps) {
        super(props);
    }

    render() {
        return <Button disabled={this.props.disabled}
                       bsStyle={getStyle(this.props.flagg || Gf.Web.Models.HandlingFlagg.Standard)}
                       className={`${this.props.className || "defaultButton"}` }
                       href={appContext.addContextPathAndFixUrl(this.props.to)}
                       onClick={this.props.onClick ? (evt: React.MouseEvent<{}>) => {
                           evt.preventDefault();
                           return this.props.onClick ? this.props.onClick(evt) : undefined;
                       } : undefined}>{this.props.children}</Button>;
    }
}


// WEBPACK FOOTER //
// ./Scripts/React/Component/ButtonLinkButton.tsx